import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import CardBodyCss from '#srcCssModules/card/card-body.module.scss';
import { CardLocationCityChooser } from '#home/components/card-location/CardLocationCityChooser';
import { CardLocationCityChooseButton } from '#home/components/card-location/CardLocationCityChooseButton';
import { CityForSelectType } from '#home/types';
import { useBaseContext } from '#base/hooks/use-base-context';
import cityChooserCss from '#srcCssModules/city-chooser/city-chooser.module.scss';

const CardLocationBody: FC = () => {
  const [selectedCity, setSelectedCity] = useState<CityForSelectType|null>(null);
  const { hasCityList } = useBaseContext();

  if (!hasCityList) {
    return null;
  }

  return (
    <div className={CardBodyCss.cardBody}>
      <div className={cityChooserCss.cityChooser}>
        <div className={cityChooserCss.cityChooser__text}>
          <FormattedMessage defaultMessage="type" />
        </div>
        <CardLocationCityChooser selectedCity={selectedCity} setSelectedCity={setSelectedCity} />
        <CardLocationCityChooseButton selectedCity={selectedCity} />
      </div>
    </div>
  );
};

export { CardLocationBody };
